import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { IconComponent } from '@shared/components/icon/icon.component';
import { IHeaderComponent, IHeaderPresenter } from './interfaces';
import { HeaderPresenter } from './header.presenter';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	imports: [CommonModule, IconComponent],
	providers: [HeaderPresenter],
	standalone: true,
})
export class HeaderComponent extends IAbstractView<IHeaderPresenter> implements IHeaderComponent {
	@Input() isHome: boolean = false;
	@Input() showMenu: boolean = true;
	@Input() showUserInfo: boolean = true;
	@Input() showLanguage: boolean = true;
	@Input() showLocation?: boolean;
	@Input() showCart?: boolean;

	auth$ = this.presenter.auth$;
	translations = this.presenter.translations;
	store$ = this.presenter.store$;
	clientLocation$ = this.presenter.clientLocation$;
	totalCartCount$ = this.presenter.totalCartCount$;
	name = this.presenter.name;
	icon = this.presenter.icon;

	constructor(presenter: HeaderPresenter) {
		super(presenter);
	}

	get displayLocation(): boolean {
		return this.showLocation !== undefined ? this.showLocation : this.isHome;
	}

	get displayCart(): boolean {
		return this.showCart !== undefined ? this.showCart : this.isHome;
	}

	toggleLanguage(): void {
		this.presenter.toggleLanguage();
	}

	openDeliveryModal(): void {
		this.presenter.openDeliveryModal();
	}

	onOpenCartMenu(): void {
		this.presenter.onOpenCartMenu();
	}

	openMainMenu(): void {
		this.presenter.openMainMenu();
	}

	getStoreAddress(): Observable<string | null> {
		return this.presenter.getStoreAddress();
	}

	getAddress(): Observable<string | null> {
		return this.presenter.getAddress();
	}
}
